import React, { useState } from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { responsive } from "../../utils/style";

import { Select, Tabs } from "antd";
import "./custom.css";

import { useReportMonk } from "../../context/reportMonk";

import ShareFB from "../Reward/ShareFB";
import Modal from "../Reward/Modal";

import { getLastReward } from "../../utils/reward";
import Share_ICON from "../../assets/icons/ShareGreenIcon.svg";

import { CustomSelect } from "../../components/CustomFields";
import useAuth from "../../utils/useAuth";
import DayTabResult from "./DayTabResult";
import WeekTabResult from "./WeekTabResult";
import SummaryTabResult from "./SummaryTabResult";
import { fontFamiliy } from "./constant";

const { Option } = Select;
const { TabPane } = Tabs;

const Main = () => {
  const {
    onChangeSelectMatch,
    getEnableDates,
    haveRewards,
    getCurrentWeekNumber,
    isLoading,
    matchList,
    getCurrentWeekLastReward,
    mode,
  } = useReportMonk();
  const [showModal, setShowModal] = useState(false);
  const [activeTab, setActiveTab] = useState("byDate");

  const { personalId } = useAuth();

  const getShareFBWeekText = () => {
    if (mode === "weeks") {
      return getCurrentWeekNumber();
    }

    return `1-${getCurrentWeekNumber()}`;
  };

  return (
    <>
      <Container>
        <Background>
          {haveRewards() && (
            <>
              <Modal
                personalId={personalId}
                week={getShareFBWeekText()}
                reward={getLastReward(getCurrentWeekLastReward())}
                visible={showModal}
                onClose={() => setShowModal(false)}
              />
              <ShareFB
                personalId={personalId}
                week={getShareFBWeekText()}
                reward={getLastReward(getCurrentWeekLastReward())}
              />
            </>
          )}

          <SelectContainer>
            <HeaderDiv>
              <Topic>ขอทราบผล</Topic>
              {activeTab === "byWeek" && (
                <>
                  <ShareFBBtn
                    style={{ float: "right" }}
                    onClick={() => setShowModal(true)}
                    disabled={!haveRewards()}
                  >
                    <img src={Share_ICON} style={{ marginRight: "8px" }} />
                    แชร์
                  </ShareFBBtn>
                </>
              )}
            </HeaderDiv>
            <SelectLabel>ชื่อกิจกรรมการแข่งขัน</SelectLabel>

            <br />

            <CustomSelect
              disabled={matchList.length <= 0}
              placeholder="ระบุ"
              style={{ borderRadius: "4px" }}
              width={"440px"}
              widthRs={"100%"}
              onChange={(v) => onChangeSelectMatch(v)}
            >
              {matchList.length &&
                matchList.map((m, i) => {
                  return (
                    <Option value={m.id} key={`option-matchList-${i}`}>
                      {m.name}
                    </Option>
                  );
                })}
            </CustomSelect>
          </SelectContainer>
          {!isLoading && (
            <>
              {getEnableDates().length ? (
                <>
                  <CustomTab
                    defaultActiveKey="byDate"
                    onChange={(key) => setActiveTab(key)}
                    centered
                  >
                    <TabPane tab="รายวัน" key="byDate">
                      <DayTabResult />
                    </TabPane>
                    <TabPane tab="รายสัปดาห์" key="byWeek">
                      <WeekTabResult />
                    </TabPane>
                    <TabPane tab="ทั้งหมด" key="bySummary">
                      <SummaryTabResult />
                    </TabPane>
                  </CustomTab>
                </>
              ) : (
                <>
                  <center>ไม่พบการกรอกข้อมูล 4 เป้าหมาย</center>
                </>
              )}
            </>
          )}
        </Background>
      </Container>
    </>
  );
};

const CustomTab = styled(Tabs)`
  .ant-tabs-ink-bar {
    background: #fc6b4b !important;
  }
`;

const HeaderDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ShareFBBtn = styled.button`
  cursor: pointer;
  background: #b5f6df;
  /* Primary/Green 400 */
  border: 1px solid #16af7b;
  border-radius: 100px;
  padding: 14px 32px;
  font-style: normal;
  font-weight: 600;
  font-size: 19px;
  line-height: 23px;
  /* identical to box height, or 121% */

  letter-spacing: -0.02em;

  /* Primary/Green 400 */

  color: #16af7b;
`;

const SelectContainer = styled.div`
  max-width: 1144px;
  width: 440px;

  ${responsive.mobile(css`
    max-width: 375px;
    padding-left: 8px;
    padding-right: 8px;
  `)}
`;

const Container = styled.div`
  width: 100%;
  background-color: #fffbeb;

  display: flex;
  justify-content: center;
  align-items: center;
  font-family: ${fontFamiliy};
`;

const Background = styled.div`
  width: 100%;
  max-width: 1144px;
  min-height: calc(100vh - 154px - 100px);

  background-color: white;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;

  padding-bottom: 80px;

  ${responsive.tablet(css`
    max-width: unset;
    padding-bottom: 50px;
  `)}

  ${responsive.mobile(css`
    padding-bottom: 40px;
  `)}
`;

const Topic = styled.h4`
  color: #058459;
  margin-top: revert;
  margin-bottom: 30px;
  font-style: normal;
  font-weight: 600;
  font-size: 23px;
  line-height: 28px;
  /* identical to box height, or 122% */

  letter-spacing: -0.02em;

  /* Primary/Green 500 */

  color: #058459;
`;

const SelectLabel = styled.span`
  size: 21px;
`;

export default Main;
